import { Button } from '@/shadcn-ui/button';
import {
  CARS_BETWEEN_MARKETING_TILE_ON_DESKTOP_MIN,
  CARS_BETWEEN_MARKETING_TILE_ON_MOBILE_MIN,
  MarketingTile,
  SPOTLIGHT_TILE_INDEX_POSITION_ON_DESKTOP,
  SPOTLIGHT_TILE_INDEX_POSITION_ON_MOBILE,
} from '../hooks/use-get-marketing-tiles';
import FlexcarIn75SecondsTile from '../components/marketing-tiles/flexcar-in-75-seconds-tile';
import GasSaverMarketingTileDrawerDialog from '../components/marketing-tiles/gas-saver-marketing-tile-drawer-dialog';
import GasSaverTile from '../components/marketing-tiles/gas-saver-tile';

interface FixedTilesProps {
  PUBLIC_CDN_URL: string;
  doesSupportWebp: boolean;
  gasSaverCents: string;
}

interface FixedTilesResult {
  fixedTiles: MarketingTile[];
  lastDesktopIndex: number;
  lastMobileIndex: number;
}

/**
 * Creates fixed position marketing tiles for inventory
 */
export function createFixedPositionMarketingTiles({
  PUBLIC_CDN_URL,
  doesSupportWebp,
  gasSaverCents,
}: FixedTilesProps): FixedTilesResult {
  // Position the GasSaverTile after the spotlight
  const gasSaverDesktopIndex =
    SPOTLIGHT_TILE_INDEX_POSITION_ON_DESKTOP + CARS_BETWEEN_MARKETING_TILE_ON_DESKTOP_MIN;
  const gasSaverMobileIndex =
    SPOTLIGHT_TILE_INDEX_POSITION_ON_MOBILE + CARS_BETWEEN_MARKETING_TILE_ON_MOBILE_MIN;

  const fixedTiles: MarketingTile[] = [
    // Spotlight tile
    {
      tile: <FlexcarIn75SecondsTile key="flexcar-in-75-seconds-tile" />,
      indexes: {
        desktop: SPOTLIGHT_TILE_INDEX_POSITION_ON_DESKTOP,
        mobile: SPOTLIGHT_TILE_INDEX_POSITION_ON_MOBILE,
      },
    },

    // Gas Saver tile
    {
      tile: (
        <GasSaverMarketingTileDrawerDialog
          key="gas-saver-tile"
          trigger={
            <Button variant="clear" className="relative aspect-square h-full w-full">
              <GasSaverTile
                PUBLIC_CDN_URL={PUBLIC_CDN_URL}
                doesSupportWebp={doesSupportWebp}
                gasSaverCents={gasSaverCents}
              />
            </Button>
          }
          gasSaverCents={gasSaverCents}
        />
      ),
      indexes: {
        desktop: gasSaverDesktopIndex,
        mobile: gasSaverMobileIndex,
      },
    },
  ];

  return {
    fixedTiles,
    lastDesktopIndex: gasSaverDesktopIndex,
    lastMobileIndex: gasSaverMobileIndex,
  };
}
